import React from "react";
import PropTypes from "prop-types";

import moment from "moment";

import { Column, Field, Control, Label, Input } from "rbx";

import {
  StateSelect,
  BooleanInput,
  PhoneNumberInput
} from "../../../../components/inputs";

const Details = ({ editing, vendor, onChange }) => (
  <React.Fragment>
    <Column.Group>
      <Column size="one-fifth">
        <Field>
          <Control expanded>
            <Label>Vendor #</Label>
            <Input
              disabled
              readOnly
              required
              autocomplete="new"
              name="VendorNo"
              type="text"
              value={vendor.VendorNo}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column size="two-fifths">
        <Field>
          <Control>
            <Label>Name</Label>
            <Input
              required
              autocomplete="new"
              name="Name"
              readOnly={!editing}
              value={vendor?.Name}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field kind="group">
          <Control expanded>
            <Label>Website</Label>
            <Input
              name="WebSite"
              readOnly={!editing}
              value={vendor?.WebSite}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              readOnly={!editing}
              value={vendor?.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>

    <Column.Group>
      <Column>
        <Field>
          <Control>
            <Label>Address 1</Label>
            <Input
              autocomplete="new"
              name="Address1"
              readOnly={!editing}
              value={vendor?.Address1}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Address 2</Label>
            <Input
              autocomplete="new"
              name="Address2"
              readOnly={!editing}
              value={vendor?.Address2}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>City</Label>
            <Input
              autocomplete="new"
              name="City"
              readOnly={!editing}
              value={vendor?.City}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>State</Label>
            <StateSelect
              name="State"
              readOnly={!editing}
              value={vendor?.State}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Zip</Label>
            <Input
              autocomplete="new"
              name="Zip"
              readOnly={!editing}
              value={vendor?.Zip}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
    <Column.Group>
      <Column>
        <Field>
          <Control>
            <Label>Contact</Label>
            <Input
              autocomplete="new"
              name="Contact"
              readOnly={!editing}
              value={vendor?.Contact}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Phone #</Label>
            <PhoneNumberInput
              name="Telephone"
              readOnly={!editing}
              value={vendor?.Telephone}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Fax #</Label>
            <PhoneNumberInput
              name="Fax"
              readOnly={!editing}
              value={vendor?.Fax}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Email</Label>
            <Input
              name="EmailAddr"
              readOnly={!editing}
              value={vendor?.EmailAddr}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control expanded>
            <Label>Last Transaction Date</Label>
            <Input
              readOnly
              type="text"
              value={
                vendor?.LastTransactionDate
                  ? moment(vendor.LastTransactionDate).format("MM/DD/YY, HH:mm")
                  : ""
              }
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
  </React.Fragment>
);

Details.propTypes = {
  editing: PropTypes.bool,
  vendor: PropTypes.object,
  onChange: PropTypes.func
};

export default Details;
